export const DIVIDE_AMOUNT = 10000000;
export const formatAmount = (amount) => {
    amount = amount ?? 0;
    return (amount / DIVIDE_AMOUNT);
}

export const truncateWalletAddress = (address, startCharCount = 14, endCharCount = 8) => {
    if (!address || address === "-") return "-";
    const endCharIndex = address.length - endCharCount;
  
    return `${address.slice(0, startCharCount)}...${address.slice(endCharIndex)}`;
};
// coinbase
export const isOnlyZero = (str) => {
  return /^0+$/.test(str);
}
export const basePath = "public";
export const netWork = process.env.REACT_APP_ENV;